/*
Item: Export Dialog component for exporting tables from Statistics.jsx
Name: ExportDialog
Format: Code/Frontend component
*/
import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { MultiLanguage } from '../../utils/MultiLanguage';

export default class ExportTableDialog extends Component {
  constructor(props) {
    super(props);
    this.multiLanguage = new MultiLanguage();
    const { onHideExportTable, exportTable } = this.props;
    this.onHideExportTable = onHideExportTable;
    this.exportTable = exportTable;
    this.state = {
      fileName: '',
      exportOption: 'XLSX',
    };
    this.exportOptions = [
      // { label: 'CSV', value: 'CSV_TABLE' },
      { label: 'Excel', value: 'XLSX' },
      { label: 'Flatfile', value: 'FLATFILECSV_TABLE' },
    ];
  }

  renderFooter() {
    const { exportOption, fileName } = this.state;
    const regex = /^[^<>*!?^"':,/\\]+$/;
    const noValidFilename = fileName.search(regex) === -1;
    return (
      <div>
        <Button
          disabled={(exportOption === '' || fileName === '' || noValidFilename)}
          label="Exportieren"
          id="save"
          type="button"
          icon="pi pi-check"
          onClick={() => {
            this.exportTable(
              exportOption, fileName,
            );
          }}
        />
        <Button
          label="Abbrechen"
          id="abortSave"
          type="button"
          icon="pi pi-times"
          onClick={() => { this.onHideExportTable(); }}
          className="p-button-danger"
        />
      </div>
    );
  }

  render() {
    const { exportTableVisible } = this.props;
    const { exportOption, fileName } = this.state;
    const { nameValue } = this.props;
    // console.log('TEST1#1', nameValue);
    return (
      <div>
        <Dialog
          header="Tabelle exportieren"
          visible={exportTableVisible}
          style={{ width: '50vw' }}
          footer={this.renderFooter()}
          onHide={this.onHideExportTable}
          modal
        >
          <div className="card">
            <div className="p-col-10">
              <span className="md-inputfield">
                <InputText
                  maxLength="99"
                  id="tableExportName"
                  value={fileName || ''}
                  keyfilter={/^[^<>*!?^"':,/\\]+$/}
                  onChange={(e) => this.setState({ fileName: e.target.value })}
                  style={{ width: '40vw' }}
                />
                <label htmlFor="tableExportName">Dateiname*</label>
              </span>
            </div>
            <div className="p-col-10">
              <div className="p-col-12">
                <b>Dateiformat</b>
              </div>
              <Dropdown
                id="exportOption"
                value={exportOption}
                options={this.exportOptions}
                onChange={(e) => this.setState({ exportOption: e.value })}
                placeholder="Dateiformat wählen"
              />
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}
